import { TripSummaryLike } from './trip-history-event-filtering-utils';

export const isTripHistoryMapItem = (item: { entityId: string; journeyId: string; tripId?: string }, trip: TripSummaryLike): boolean => {
  return item.entityId === trip.entityId && item.journeyId === trip.journeyId && item.tripId === trip.id;
};

export const isSameTripJourneyMapItem = (item: { entityId: string; journeyId: string }, trip: TripSummaryLike): boolean => {
  return item.entityId === trip.entityId && item.journeyId === trip.journeyId;
};
